<his-plam [label]="setting().label | hisUi"
          [helptext]="setting().helptext | hisUi" [required]="setting().required"
          [title]="title()">
    <input #content [(ngModel)]="setting().value" hisInteger type="number" step="1" class="inputWidth100"
           [min]="minValue()"
           [max]="maxValue()"
           [readonly]="setting().readonly">
</his-plam>
